// extracted by mini-css-extract-plugin
export default {"main":"f0fe331984","tit":"_08d3c967b7","maintitle":"_2307626a47","ylw":"_5279d40bf0","white":"_1623b3a5db","mv_title":"a839c2e332","mv_nc":"_02c8ca97d2","mv_in":"_66764697bc"};